import styled from 'styled-components'

export const ChartShell = styled.div`
  --analytics-chart-accent: ${p => p.theme.palette.blue.main};
  --analytics-chart-secondary: ${p => p.theme.palette.green.main};
  --analytics-chart-tertiary: ${p => p.theme.palette.warning.main};
  --analytics-chart-quaternary: ${p => p.theme.palette.info.main};
  --analytics-activity-one: #155dfc;
  --analytics-activity-two: #3c7afd;
  --analytics-activity-three: #6596fd;
  --analytics-activity-four: #8cb1fe;
  --analytics-activity-five: #b4ccfe;
  --analytics-chart-grid: ${p => p.theme.palette.colors.borderSoft};
  --analytics-chart-muted: ${p => p.theme.palette.colors.subdued};

  width: 100%;
  min-width: 0;

  .apexcharts-canvas, .apexcharts-svg { max-width: 100% !important; }
  .apexcharts-tooltip, .apexcharts-xaxistooltip {
    border: 1px solid ${p => p.theme.palette.colors.borderStrong} !important;
    border-radius: 10px !important;
    background: ${p => p.theme.palette.colors.surfaceElevatedStrong} !important;
    box-shadow: 0 14px 34px ${p => p.theme.palette.colors.shadowStrong} !important;
    color: ${p => p.theme.palette.colors.text} !important;
  }
  .apexcharts-tooltip-title {
    border-bottom-color: ${p => p.theme.palette.colors.borderSoft} !important;
    background: ${p => p.theme.palette.colors.surfaceElevated} !important;
  }
  .apexcharts-legend-text { color: ${p => p.theme.palette.colors.muted} !important; }
`

export const ChartEmpty = styled.div`
  display: grid;
  min-height: 260px;
  place-items: center;
  border-block: 1px solid ${p => p.theme.palette.colors.borderSoft};
  color: ${p => p.theme.palette.colors.subdued};
  font: 500 13px/1.5 Poppins, sans-serif;
`
